var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',_vm._l((_vm.rotas),function(rota){return _c('li',{key:rota,staticClass:"lista"},[_c('router-link',{attrs:{"to":rota.path ? rota.path : '/home'}},[_vm._v(" "+_vm._s(rota.titulo))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }